module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-107.4af38a9.woff2";